AgrimarketControllers.controller('userContractsSurfaceCommitmentMonitoringController', ['$scope', '$rootScope', '$routeParams', '$filter', 'configurationFactory',
    'contractsService', '$sce', 'colonnesContractsSurfaceCommitmentValidated',
    function ($scope, $rootScope, $routeParams, $filter, configurationFactory, contractsService, $sce, colonnesContractsSurfaceCommitmentValidated) {

        
    }]);
